export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 }
];

export const initialFilter = {
  filter: {
    name: "",
    is_activated_label: null,
    is_activated: null,
    is_expired_label: null,
    is_expired: null,
    organization_regional_label: null,
    organization_regional_uuid: null,
    organization_category_uuid: null
  },
  pageNumber: 1,
  pageSize: 10
};

export const SIMPZ_STATUS = {
  REGISTER: "REGISTER",
  DATA_UPLOAD: "DATA_UPLOAD",
  ACTIVE: "ACTIVE"
};

export const SIMPZ_STATUS_ARRAY = [
  { value: SIMPZ_STATUS.REGISTER, label: SIMPZ_STATUS.REGISTER },
  { value: SIMPZ_STATUS.DATA_UPLOAD, label: "DATA UPLOAD" },
  { value: SIMPZ_STATUS.ACTIVE, label: SIMPZ_STATUS.ACTIVE }
];

export const CLASSIFICATION_ARRAY = [
  {
    label: "Kurang dari 1 Miliar",
    value: false
  },
  {
    label: "Lebih dari 1 Miliar",
    value: true
  }
];
